import React from 'react';
import PropTypes from 'prop-types';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { AdLabel } from 'client/site-modules/shared/components/native-ad/native-ad-components/ad-label/ad-label';
import { getRelAttribute } from 'site-modules/shared/components/native-ad/utils/get-rel-attribute';

export function PartnerPromoAd({ content = null, isMobile = false }) {
  if (!content) {
    return null;
  }
  const { logo, image, copy, urlText, url, urlMobile, urlTargetNew, adLabel } = content;
  const isSponsored = adLabel === 'Ad';
  const rel = getRelAttribute(isSponsored, urlTargetNew);

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={isMobile ? urlMobile : url} target={urlTargetNew ? '_blank' : ''} rel={rel} className="d-inline-block">
      <div className="image-wrapper pos-r mx-auto">
        {adLabel && logo && (
          <img
            className="oem-logo pos-a"
            alt=""
            src={getStaticImageUrl(logo)}
            height={'20'}
            decoding="async"
            loading="lazy"
          />
        )}
        {image && (
          <img
            className="jellybean d-block m-auto"
            alt=""
            src={getStaticImageUrl(image)}
            decoding="async"
            loading="lazy"
          />
        )}
        {adLabel && <AdLabel styles={{ top: '0px', right: '0px' }} />}
      </div>
      <div className="size-16 fw-bold text-gray-darker copy">{copy && <ContentFragment>{copy}</ContentFragment>}</div>
      <div className="small text-primary-darker url">
        {urlText}
        {urlTargetNew && <i className="icon-open_in_new ms-0_25 size-10" aria-hidden />}
      </div>
    </a>
  );
}

PartnerPromoAd.propTypes = {
  content: PropTypes.shape({}),
  isMobile: PropTypes.bool,
};
